import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from './client';
import type { AnalyticsOverview, DataEnvelope } from './types';

export type AnalyticsDays = 7 | 14 | 30 | 90;

export function useAnalyticsOverview(days: AnalyticsDays) {
  return useQuery<AnalyticsOverview>({
    queryKey: ['analytics', 'overview', days],
    queryFn: ({ signal }) =>
      api<DataEnvelope<AnalyticsOverview>>('/analytics/overview', { query: { days }, signal }).then(
        (r) => r.data,
      ),
    placeholderData: keepPreviousData,
    refetchInterval: 60_000,
  });
}
